import { render, staticRenderFns } from "./SurveySingle.vue?vue&type=template&id=74533127&"
import script from "./SurveySingle.vue?vue&type=script&lang=js&"
export * from "./SurveySingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports